import { idDocumentSides } from '../../../utils/vietnam';

const identityLabel = (identityTypeID, side) => {
  if (Number(identityTypeID) === 1) return side === 'front' ? 'CCCD Front' : 'CCCD Back';
  if (Number(identityTypeID) === 2) return 'Passport';
  if (Number(identityTypeID) === 4) return 'Enterprise Registration';
  return 'Identity Front';
};

const purchaserName = (bookingCustomer = {}) => {
  const customer = bookingCustomer.customer || {};
  return bookingCustomer.preferredName || bookingCustomer.name || customer.preferredName ||
    customer.name || customer.fullName || 'Purchaser';
};

const sidesFor = (bookingCustomer) => {
  const customer = bookingCustomer.customer || {};
  return idDocumentSides(customer.identityTypeID, true) === 2 ? ['front', 'back'] : ['front'];
};

const unavailable = (bookingCustomer, side, pending) => {
  const customer = bookingCustomer.customer || {};
  const label = identityLabel(customer.identityTypeID, side);
  return {
    id: `booking-current-${bookingCustomer.customerID}-${side}-${pending ? 'loading' : 'unavailable'}`,
    currentIdentityDocument: true,
    currentIdentityUnavailable: !pending,
    currentIdentityPending: pending,
    customerID: bookingCustomer.customerID,
    fileName: `${label} — ${pending ? 'loading' : 'unavailable'}`,
    fileType: 'identity',
    purchaserName: purchaserName(bookingCustomer),
    currentIdentityLabel: label,
  };
};

const localDocument = (bookingCustomer, side, bookApiURL) => {
  const customer = bookingCustomer.customer || {};
  const document = side === 'front' ? customer.icFrontDocument : customer.icBackDocument;
  const documentID = side === 'front' ? customer.icFrontDocumentID : customer.icBackDocumentID;
  const label = identityLabel(customer.identityTypeID, side);
  if (!document ||
    !document.key ||
    document.id == null ||
    String(document.id) !== String(documentID)) {
    return unavailable(bookingCustomer, side, false);
  }
  return {
    id: `booking-current-${bookingCustomer.customerID}-${side}`,
    currentIdentityDocument: true,
    customerID: bookingCustomer.customerID,
    identityURL: `${bookApiURL}/customers/${encodeURIComponent(customer.id)}/documents/${encodeURIComponent(document.id)}/view/`,
    fileName: document.name || label,
    fileType: 'identity',
    fileSizeBytes: document.size,
    createdAt: document.createdAt,
    purchaserName: purchaserName(bookingCustomer),
    currentIdentityLabel: label,
  };
};

const sharedDocument = (booking, bookingCustomer, side, info, bookApiURL) => {
  const customer = bookingCustomer.customer || {};
  const metadata = info[side];
  const label = identityLabel(customer.identityTypeID, side);
  if (!metadata || !metadata.available || !metadata.version) {
    return unavailable(bookingCustomer, side, false);
  }
  const path = `/bookings/${encodeURIComponent(booking.id)}/customers/${encodeURIComponent(bookingCustomer.customerID)}/crm_identity/${side}/?v=${encodeURIComponent(metadata.version)}`;
  return {
    id: `booking-current-${bookingCustomer.customerID}-${side}-${metadata.version}`,
    currentIdentityDocument: true,
    customerID: bookingCustomer.customerID,
    identityURL: `${bookApiURL}${path}`,
    fileName: metadata.name || label,
    fileType: 'identity',
    fileSizeBytes: metadata.fileSizeBytes,
    createdAt: metadata.createdAt,
    uploaderName: metadata.uploaderName,
    purchaserName: purchaserName(bookingCustomer),
    currentIdentityLabel: label,
  };
};

// Bookings Documents follows the Purchaser tab: a CRM-linked purchaser uses the versioned
// crm_identity endpoints; an unlinked purchaser uses its current local document pointer.
export const getCurrentBookingIdentityDocuments = (booking, identities, loading, bookApiURL) => {
  if (!booking || !Array.isArray(booking.bookingCustomers)) return [];
  return booking.bookingCustomers.reduce((rows, bookingCustomer) => {
    if (!bookingCustomer || !bookingCustomer.customerID || !bookingCustomer.customer) return rows;
    const info = identities && identities[bookingCustomer.customerID];
    sidesFor(bookingCustomer).forEach((side) => {
      if (!booking.purchasersIsolated) rows.push(localDocument(bookingCustomer, side, bookApiURL));
      else if (!info && loading) rows.push(unavailable(bookingCustomer, side, true));
      else if (info && info.status === 'shared') rows.push(sharedDocument(booking, bookingCustomer, side, info, bookApiURL));
      else if (info && info.status !== 'error') rows.push(localDocument(bookingCustomer, side, bookApiURL));
      else rows.push(unavailable(bookingCustomer, side, false));
    });
    return rows;
  }, []);
};

export const bookingUsesCurrentIdentityDocuments = booking => !!booking;



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/bookingCurrentIdentityDocuments.js